module.exports = __webpack_public_path__ + "footer-icon-brunch.b0e7935bd51d9cd6e463.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/footer-icon-brunch.svg
// module id = 1013
// module chunks = 2